import Tooltip from "@/v2-ui/tooltip"
import Icon from "@/v2-ui/icon"
import cn from "@/v2-ui/utils/utils.cn"

export type UserFlaggedBadgeProps = {
  className?: string
}

// UserFlaggedBadge marks a user that's flagged for single-active-session
// enforcement (the account-sharing flag). It explains what that means on
// hover, since the bare "Flagged" label in the table/filter is otherwise
// opaque. Set/clear the flag itself from the user panel's sharing-flag card.
function UserFlaggedBadge(props: UserFlaggedBadgeProps) {
  const { className } = props

  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <span
          className={cn(
            "inline-flex items-center gap-1 font-medium",
            className,
          )}
        >
          <Icon src="flag" className="text-destructive-foreground" size={12} />
          Flagged
        </span>
      </Tooltip.Trigger>

      <Tooltip.Content side="top" className="ui-tooltip-content--panel">
        <div className="flex flex-col gap-1 p-3">
          <p className="font-medium">Flagged for single active session</p>
          <p className="text-muted-foreground">
            This user can only be signed in on one device at a time. On a second
            device they get a choice screen instead of a silent login — used to
            curb account sharing. Manage it from the user's Sign-in tab.
          </p>
        </div>
      </Tooltip.Content>
    </Tooltip>
  )
}

export default UserFlaggedBadge
